import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "card-header border-0 pt-5" }
const _hoisted_2 = { class: "card-title align-items-start flex-column" }
const _hoisted_3 = { class: "card-label fw-bolder fs-3 mb-1" }
const _hoisted_4 = { class: "card-toolbar" }
const _hoisted_5 = { class: "d-flex align-items-center position-relative my-1" }
const _hoisted_6 = {
  id: "kt_account_profile_details",
  class: "collapse show"
}
const _hoisted_7 = { class: "card-body border-top p-9" }
const _hoisted_8 = { class: "row mb-6" }
const _hoisted_9 = { class: "col-lg-6 fv-row" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Nama Area", -1)
const _hoisted_11 = { class: "col-lg-6 fv-row" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Penanggung Jawab", -1)
const _hoisted_13 = { class: "row mb-6" }
const _hoisted_14 = { class: "col-lg-6 fv-row" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Email", -1)
const _hoisted_16 = { class: "col-lg-6 fv-row" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Nomor Telepon", -1)
const _hoisted_18 = { class: "row mb-6" }
const _hoisted_19 = { class: "col-lg-6 fv-row" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Provinsi", -1)
const _hoisted_21 = { class: "col-lg-6 fv-row" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Kabupaten", -1)
const _hoisted_23 = { class: "row mb-6" }
const _hoisted_24 = { class: "col-lg-6 fv-row" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Kecamatan", -1)
const _hoisted_26 = { class: "col-lg-6 fv-row" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Alamat Lengkap", -1)
const _hoisted_28 = { class: "card-header border-0 pt-5" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("h3", { class: "card-title align-items-start flex-column" }, null, -1)
const _hoisted_30 = { class: "card-toolbar" }
const _hoisted_31 = { class: "d-flex align-items-center position-relative my-1" }
const _hoisted_32 = { class: "svg-icon svg-icon-1 position-absolute ms-6" }
const _hoisted_33 = { class: "card-body py-3" }
const _hoisted_34 = { class: "table-responsive" }
const _hoisted_35 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder text-muted bg-light" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-200px; text-center" }, "Cabang"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px; text-center" }, "Jumlah Funding"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px; text-center" }, "Jumlah Sekolah"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px; text-center" }, "Jumlah Siswa"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px; text-center" }, "Aksi")
  ])
], -1)
const _hoisted_37 = { key: 0 }
const _hoisted_38 = { class: "text-center" }
const _hoisted_39 = { class: "text-center" }
const _hoisted_40 = { class: "text-center" }
const _hoisted_41 = { class: "text-center" }
const _hoisted_42 = { class: "text-center" }
const _hoisted_43 = ["onClick"]
const _hoisted_44 = /*#__PURE__*/_createElementVNode("img", {
  src: "/media/icons/detail.svg",
  alt: ""
}, null, -1)
const _hoisted_45 = [
  _hoisted_44
]
const _hoisted_46 = ["onClick"]
const _hoisted_47 = /*#__PURE__*/_createElementVNode("img", {
  src: "/media/icons/edit.svg",
  alt: ""
}, null, -1)
const _hoisted_48 = [
  _hoisted_47
]
const _hoisted_49 = ["onClick"]
const _hoisted_50 = /*#__PURE__*/_createElementVNode("img", {
  src: "/media/icons/delete.svg",
  alt: ""
}, null, -1)
const _hoisted_51 = [
  _hoisted_50
]
const _hoisted_52 = { key: 1 }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    colspan: "7",
    style: {"text-align":"center"}
  }, "Tidak Ada Data")
], -1)
const _hoisted_54 = [
  _hoisted_53
]
const _hoisted_55 = { class: "row mt-5 mb-5" }
const _hoisted_56 = { class: "col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start" }
const _hoisted_57 = {
  class: "dataTables_length",
  id: "kt_customers_table_length"
}
const _hoisted_58 = ["label", "value"]
const _hoisted_59 = { class: "p-3" }
const _hoisted_60 = { class: "col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end" }
const _hoisted_61 = { class: "pagination" }
const _hoisted_62 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([_ctx.widgetClasses, "card"])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h3", _hoisted_2, [
        _createElementVNode("span", _hoisted_3, "Detail " + _toDisplayString(_ctx.detail.name), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("button", {
            class: "btn btn-primary me-3",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/superadmin/area')))
          }, " Kembali ")
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createVNode(_component_Field, {
              type: "text",
              name: "name",
              placeholder: "",
              autocomplete: "off",
              class: "form-control form-control-lg form-control-solid",
              modelValue: _ctx.detail.name,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.detail.name) = $event)),
              readonly: ""
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createVNode(_component_Field, {
              type: "text",
              name: "picArea",
              placeholder: "",
              autocomplete: "off",
              class: "form-control form-control-lg form-control-solid",
              modelValue: _ctx.detail.picArea,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.detail.picArea) = $event)),
              readonly: ""
            }, null, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _createVNode(_component_Field, {
              type: "text",
              name: "email",
              placeholder: "",
              autocomplete: "off",
              class: "form-control form-control-lg form-control-solid",
              modelValue: _ctx.detail.email,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.detail.email) = $event)),
              readonly: ""
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _hoisted_17,
            _createVNode(_component_Field, {
              type: "text",
              name: "phone",
              placeholder: "",
              autocomplete: "off",
              class: "form-control form-control-lg form-control-solid",
              modelValue: _ctx.detail.phone,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.detail.phone) = $event)),
              readonly: ""
            }, null, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _hoisted_20,
            _createVNode(_component_Field, {
              type: "text",
              name: "name",
              placeholder: "",
              autocomplete: "off",
              class: "form-control form-control-lg form-control-solid",
              modelValue: _ctx.detail.address.province,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.detail.address.province) = $event)),
              readonly: ""
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _hoisted_22,
            _createVNode(_component_Field, {
              type: "text",
              name: "picArea",
              placeholder: "",
              autocomplete: "off",
              class: "form-control form-control-lg form-control-solid",
              modelValue: _ctx.detail.address.city,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.detail.address.city) = $event)),
              readonly: ""
            }, null, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, [
            _hoisted_25,
            _createVNode(_component_Field, {
              type: "text",
              name: "picArea",
              placeholder: "",
              autocomplete: "off",
              class: "form-control form-control-lg form-control-solid",
              modelValue: _ctx.detail.address.regency,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.detail.address.regency) = $event)),
              readonly: ""
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_26, [
            _hoisted_27,
            _withDirectives(_createElementVNode("textarea", {
              class: "form-control form-control-lg form-control-solid",
              type: "text",
              placeholder: "",
              name: "note",
              autocomplete: "off",
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.detail.address.detail) = $event)),
              readonly: ""
            }, null, 512), [
              [_vModelText, _ctx.detail.address.detail]
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_28, [
      _hoisted_29,
      _createElementVNode("div", _hoisted_30, [
        _createElementVNode("div", _hoisted_31, [
          _createElementVNode("span", _hoisted_32, [
            _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen021.svg" })
          ]),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control w-250px ps-15",
            placeholder: "Cari Nama Cabang",
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.branchName) = $event)),
            onKeyup: _cache[10] || (_cache[10] = ($event: any) => (_ctx.changePageSize(_ctx.e)))
          }, null, 544), [
            [_vModelText, _ctx.branchName]
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_33, [
      _createElementVNode("div", _hoisted_34, [
        _createElementVNode("table", _hoisted_35, [
          _hoisted_36,
          (this.tableData.length)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_37, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableData, (item, index) => {
                  return (_openBlock(), _createElementBlock("tr", { key: index }, [
                    _createElementVNode("td", _hoisted_38, _toDisplayString(item.branchName), 1),
                    _createElementVNode("td", _hoisted_39, _toDisplayString(item.totalFundings), 1),
                    _createElementVNode("td", _hoisted_40, _toDisplayString(item.totalClients), 1),
                    _createElementVNode("td", _hoisted_41, _toDisplayString(item.totalUsers), 1),
                    _createElementVNode("td", _hoisted_42, [
                      _createElementVNode("a", {
                        class: "symbol symbol-35px me-2",
                        "data-bs-toggle": "tooltip",
                        title: "Detail",
                        style: {"cursor":"pointer"},
                        onClick: ($event: any) => (
                      _ctx.$router.push(
                        '/superadmin/branch/detail/' +
                          _ctx.$route.params.idBank +
                          '/' +
                          _ctx.$route.params.idArea +
                          '/' +
                          item.branchId
                      )
                    )
                      }, _hoisted_45, 8, _hoisted_43),
                      _createElementVNode("a", {
                        class: "symbol symbol-35px me-2",
                        "data-bs-toggle": "tooltip",
                        title: "Edit",
                        style: {"cursor":"pointer"},
                        onClick: ($event: any) => (
                      _ctx.$router.push(
                        '/superadmin/branch/' +
                          _ctx.$route.params.idBank +
                          '/' +
                          _ctx.$route.params.idArea +
                          '/' +
                          item.branchId
                      )
                    )
                      }, _hoisted_48, 8, _hoisted_46),
                      (_ctx.isShow)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 0,
                            class: "symbol symbol-35px me-2",
                            "data-bs-toggle": "tooltip",
                            title: "Hapus",
                            style: {"cursor":"pointer"},
                            onClick: ($event: any) => (_ctx.handleDelete(index, item))
                          }, _hoisted_51, 8, _hoisted_49))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("tbody", _hoisted_52, _hoisted_54))
        ])
      ]),
      _createElementVNode("div", _hoisted_55, [
        _createElementVNode("div", _hoisted_56, [
          _createElementVNode("div", _hoisted_57, [
            _createElementVNode("label", null, [
              _withDirectives(_createElementVNode("select", {
                name: "kt_customers_table_length",
                class: "form-select form-select-sm form-select-solid",
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.paging.size) = $event)),
                placeholder: "Per page",
                onChange: _cache[12] || (_cache[12] = ($event: any) => (_ctx.changePageSize()))
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paging.perPageOptions, (item) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: item,
                    label: item,
                    value: item
                  }, null, 8, _hoisted_58))
                }), 128))
              ], 544), [
                [_vModelSelect, _ctx.paging.size]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_59, " Showing " + _toDisplayString(_ctx.from + 1) + " to " + _toDisplayString(_ctx.to) + " of " + _toDisplayString(_ctx.paging.totalElements) + " entries ", 1)
        ]),
        _createElementVNode("div", _hoisted_60, [
          _createElementVNode("ul", _hoisted_61, [
            _createElementVNode("li", {
              class: _normalizeClass(["page-item previous", { disabled: _ctx.paging.page + 1 === 1 }])
            }, [
              _createElementVNode("a", {
                class: "page-link",
                style: {"cursor":"pointer"},
                onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.prevPage && _ctx.prevPage(...args)))
              }, " Previous ")
            ], 2),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.range(1, _ctx.paging.totalPages), (item) => {
              return (_openBlock(), _createElementBlock("li", {
                class: _normalizeClass(["page-item", { active: _ctx.paging.page + 1 === item }]),
                key: item
              }, [
                (Math.abs(item - _ctx.paging.page) <= 2)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      class: "page-link",
                      onClick: ($event: any) => (_ctx.changePage(item))
                    }, _toDisplayString(item), 9, _hoisted_62))
                  : _createCommentVNode("", true)
              ], 2))
            }), 128)),
            _createElementVNode("li", {
              class: _normalizeClass(["page-item next", { disabled: _ctx.paging.page + 1 === _ctx.paging.totalPages }])
            }, [
              _createElementVNode("a", {
                class: "page-link",
                style: {"cursor":"pointer"},
                onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.nextPage && _ctx.nextPage(...args)))
              }, " Next ")
            ], 2)
          ])
        ])
      ])
    ])
  ], 2))
}